import { useEffect, useState } from 'react';
import { Alert, Box, Button, Chip, CircularProgress, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { listarDestinos } from '../../../api/arquivoRetorno';
import RetornosDialog from './RetornosDialog';

export default function ArquivoRetorno() {
    const [dados, setDados] = useState([]);
    const [total, setTotal] = useState(0);
    const [pagina, setPagina] = useState({ page: 0, size: 10 });
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState('');
    const [atualizacao, setAtualizacao] = useState(0);
    const [selecionado, setSelecionado] = useState(null);

    useEffect(() => {
        let atual = true;
        setCarregando(true); setErro(''); setDados([]); setTotal(0);
        listarDestinos({ start: pagina.page * pagina.size, size: pagina.size })
            .then(({ data }) => { if (atual) { setDados(data.data || []); setTotal(data.meta?.totalRowCount || 0); } })
            .catch(e => { if (atual) setErro(e?.response?.data?.message || 'Não foi possível consultar as contas e convênios. Atualize a consulta.'); })
            .finally(() => { if (atual) setCarregando(false); });
        return () => { atual = false; };
    }, [pagina, atualizacao]);

    return <Box sx={{ p: { xs: 1, sm: 3 }, color: 'text.primary' }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="h5" component="h1">Arquivos de retorno</Typography>
            <Button type="button" disabled={carregando || Boolean(selecionado)} onClick={() => setAtualizacao(v => v + 1)}>Atualizar</Button>
        </Stack>
        <Typography sx={{ mb: 2 }}>Selecione a conta e o convênio para importar arquivos Sicredi CNAB 240 ou consultar o histórico.</Typography>
        <Alert severity="info" sx={{ mb: 2 }}>A importação registra as ocorrências. Esta etapa não efetua baixas nem gera despesas de tarifa.</Alert>
        {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}
        {carregando && <CircularProgress size={24} aria-label="Consultando contas e convênios" />}
        <TableContainer component={Paper} variant="outlined">
            <Table size="small" aria-label="Contas e convênios para arquivos de retorno">
                <TableHead><TableRow>{['Empresa', 'Conta', 'Convênio', 'Carteira', 'Situação', 'Arquivos'].map(t => <TableCell key={t}>{t}</TableCell>)}</TableRow></TableHead>
                <TableBody>
                    {dados.map(r => <TableRow key={`${r.conta.uuid}:${r.convenio.uuid}`}>
                        <TableCell>{r.empresa.descricao || `Empresa ${r.empresa.id}`}</TableCell>
                        <TableCell>{r.conta.descricao}</TableCell>
                        <TableCell>{r.convenio.descricao}<Typography variant="caption" component="div">Código: {r.convenio.codigoConvenio || 'Não informado'}</Typography></TableCell>
                        <TableCell>{r.convenio.carteira || 'Não informada'}</TableCell>
                        <TableCell><Chip size="small" label={!r.conta.ativo ? 'Conta inativa' : !r.convenio.ativo ? 'Convênio inativo' : 'Ativos'} color={r.conta.ativo && r.convenio.ativo ? 'success' : 'default'} /></TableCell>
                        <TableCell><Button type="button" disabled={carregando} onClick={() => setSelecionado(r)}>Acessar retornos</Button></TableCell>
                    </TableRow>)}
                    {!carregando && !erro && !dados.length && <TableRow><TableCell colSpan={6}>Nenhum convênio encontrado nesta página nas empresas autorizadas.</TableCell></TableRow>}
                </TableBody>
            </Table>
        </TableContainer>
        <TablePagination component="div" count={total} page={pagina.page} rowsPerPage={pagina.size} rowsPerPageOptions={[10, 25, 50]} labelRowsPerPage="Por página"
            labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
            backIconButtonProps={{ disabled: carregando || pagina.page === 0, title: 'Página anterior' }}
            nextIconButtonProps={{ disabled: carregando || (pagina.page + 1) * pagina.size >= total, title: 'Próxima página' }} SelectProps={{ disabled: carregando }}
            onPageChange={(_, page) => setPagina(p => ({ ...p, page }))} onRowsPerPageChange={e => setPagina({ page: 0, size: Number(e.target.value) })} />
        {selecionado && <RetornosDialog key={`${selecionado.conta.uuid}:${selecionado.convenio.uuid}`} conta={selecionado.conta} convenio={selecionado.convenio}
            onClose={() => { setSelecionado(null); setAtualizacao(v => v + 1); }} />}
    </Box>;
}
